import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Peek = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width="16"
      height="16"
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g id="Front Icon">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 4H13.5V12H2.5L2.5 4ZM1.5 4C1.5 3.44772 1.94772 3 2.5 3H13.5C14.0523 3 14.5 3.44772 14.5 4V12C14.5 12.5523 14.0523 13 13.5 13H2.5C1.94772 13 1.5 12.5523 1.5 12V4ZM12.5 5H8.5V11H12.5V5Z"
          fill={color}
        />
      </g>
    </svg>
  )
})

export default Peek
